import useSettings, { IWebsiteConfigs } from 'store/settings';
import LiveChat from './LiveChat';
import ZendeskChat from './Zendesk';
import { IGlobalSettings, IGlobalSettingsMeta } from 'api/settings';
import useGlobalSettings from 'store/globalSettings';

const Chat = () => {
  const [
    {
      data: { meta = {} as IWebsiteConfigs },
    },
  ] = useSettings();

  const [
    {
      data = {} as Partial<IGlobalSettings>,
    },
  ] = useGlobalSettings();

  const globalSettingsMeta = data.meta || ({} as IGlobalSettingsMeta);


  if (meta.zendeskKey) return <ZendeskChat secretKey={meta.zendeskKey} />;

  if (globalSettingsMeta.liveChatKey) return <LiveChat secretKey={globalSettingsMeta.liveChatKey} />;

  return null;
};

export default Chat;
